import translation from 'locales/translation';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import assessorApi, { ComissaoEleitoral } from 'api/Assessor/evento';
import associadoApi from 'api/EventoAssociado/evento';

import { List, ListItem, ListItemText } from '@material-ui/core';
import { SyncIcon } from 'components/Icons';
import Modal, {
  IGenericModalProps,
} from 'components/Modal/__LEGACY__/GenericModal/GenericModal';

import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from 'store/modules/ModalsReducer';

import ErrorHandler from 'helpers/utils/ErrorHandler';

import useStyle from './style';

export interface ComissaoEleitoralProps extends IGenericModalProps {
  key: string;
  idEvento: number;
  isAssessor?: boolean;
}

interface Props extends IModalProps {
  genericProps: ComissaoEleitoralProps;
}

export default function ComissaoEleitoralModal({ genericProps, open }: Props) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState<boolean>(false);
  const [comissao, setComissao] = useState<ComissaoEleitoral>([]);

  const handleClose = useCallback(() => {
    dispatch(modalsActionsClose(genericProps.key));
  }, [genericProps, dispatch]);

  useEffect(() => {
    const getComissao = async () => {
      setLoading(true);
      const { fail, data } = genericProps.isAssessor
        ? await assessorApi.listarComissaoEleitoral(genericProps.idEvento)
        : await associadoApi.listarComissaoEleitoral(genericProps.idEvento);
      if (fail) {
        ErrorHandler(fail);
      }
      if (data) {
        setComissao(data);
      }
      setLoading(false);
    };
    getComissao();
  }, [genericProps]);

  return (
    <Modal
      open={open ?? false}
      title={translation.AssembleiaPauta.tabPauta.comissao}
      genericProps={{
        maxWidth: 'sm',
        onClose: handleClose,
        DialogContentProps: {
          className: classes.root,
        },
      }}
      content={
        <List>
          {isLoading ? (
            <ListItem className={classes.item}>
              <ListItemText>
                <SyncIcon animated />
                {translation.RespostaPautaModal.loading}
              </ListItemText>
            </ListItem>
          ) : (
            comissao.map((membro, index) => (
              <ListItem key={index} className={classes.item}>
                <ListItemText>{membro.nomeAssociado}</ListItemText>
              </ListItem>
            ))
          )}
        </List>
      }
    />
  );
}
